import { Role } from '../lib/types'
export const BASE_URL = process.env.REACT_APP_GBC_BASE_URL || ' http://0.0.0.0:4000'

// User and auth routes
export const USER_SIGN_IN = `${BASE_URL}/auth/login`
export const SIGN_OUT = `${BASE_URL}/auth/logout`
export const RESET_PASSWORD = `${BASE_URL}/user/reset-password`
export const UPLOAD_FILE = `${BASE_URL}/file/upload`
export const UPLOAD_ALLOTMENT_CONFIRMATION = `${BASE_URL}/file/allotment-confirmation/upload`
export const UPLOAD_FUND_ALLOCATION = `${BASE_URL}/file/job`
export const UPLOAD_QUARTERLY_REPORT_JOB = `${BASE_URL}/file/job`
export const GET_JOB_LIST = `${BASE_URL}/file/jobs`
export const PREVIEW_FILE = `${BASE_URL}/file/preview`
export const DELETE_PROJECT = `${BASE_URL}/project/delete`

// Investor routes
export const INVESTORS_LIST = (roles: Role) => `${BASE_URL}/user/all?roles=${roles}`

// Investment routes
export const SEARCH_INVESTMENTS = `${BASE_URL}/investments/search`
export const UPDATE_INVESTMENT_STATUS = `${BASE_URL}/investments/status`
export const GET_INVESTMENT_DETAIL_FOR_INVESTOR = `${BASE_URL}/investments/user/details`

// Queries route
export const SEARCH_QUERIES = `${BASE_URL}/contact-us/search`

// v1

// Investor routes
export const INVESTORS_LIST_V1 = `${BASE_URL}/v1/user/all`
export const BLOCK_UNBLOCK_ACCOUNT_V1 = `${BASE_URL}/v1/user`

// Investment routes
export const SET_INVESTMENT_LIMIT_V1 = `${BASE_URL}/v1/user/investment-limit`

export const USER_SIGN_IN_V1 = `${BASE_URL}/v1/auth/login`
export const USER_LOGOUT_V1 = `${BASE_URL}/v1/auth/logout`
export const ADMIN_CHANGE_PASSWORD_V1 = `${BASE_URL}/v1/auth/admin/change-password`
export const SEARCH_OPPORTUNITIES = `${BASE_URL}/v1/opportunity/search`
export const GET_ALL_OPPORTUNITIES = `${BASE_URL}/v1/opportunity/all`
export const GET_ASSET_CLASSES = `${BASE_URL}/v1/opportunity/asset-classes`
export const GET_SECTORS = `${BASE_URL}/v1/opportunity/sectors`
export const GET_OPPORTUNITY_BY_ID = `${BASE_URL}/v1/opportunity`
export const CREATE_NEW_OPPORTUNITY = `${BASE_URL}/v1/opportunity`
export const UPDATE_OPPORTUNITY = `${BASE_URL}/v1/opportunity`
export const GET_INVESTMENT_BY_ID = `${BASE_URL}/v1/investments`
export const UPDATE_INVESTMENT_STATUS_V1 = `${BASE_URL}/v1/investments/status`
export const UPDATE_TRADE_EXECUTED_INVESTMENT_V1 = `${BASE_URL}/v1/investments/trade-executed`
export const GET_INVESTMENT_AUDIT_LOG_V1 = (investmentId: number) =>
  `${BASE_URL}/v1/investments/${investmentId}/audit-log`
export const SEARCH_INVESTMENTS_V1 = `${BASE_URL}/v1/investments/search`

export const INVESTOR_PROFILE_v1 = (investorId: number) =>
  `${BASE_URL}/v1/user/${investorId}/profile`
export const GET_INVESTMENT_DETAIL_FOR_INVESTOR_V1 = (investorId: number) =>
  `${BASE_URL}/v1/investments/investor/${investorId}`
export const SEND_VERIFICATION_LINK_V1 = `${BASE_URL}/v1/user/resend/verify-email`

// Queries route
export const SEARCH_QUERIES_V1 = `${BASE_URL}/v1/contact-us/search`
export const SEARCH_BUSINESS_INQUIRIES_V1 = `${BASE_URL}/v1/contact-us/business/search`

// Orders route
export const SEARCH_ORDERS_V1 = `${BASE_URL}/v1/orders`

// Document route
export const GET_DOCUMENT_DOWNLOAD_LINK_V1 = `${BASE_URL}/v1/documents/document-download-link`

// KYC route
export const GET_KYC_V1 = (investorId: string) => `${BASE_URL}/v1/kyc/${investorId}`
export const GET_KYC_REPORT_LINK_V1 = `${BASE_URL}/v1/kyc/sumsub/generate/kyc-report-link`
export const GET_DOCUMENT_WITH_KYC_V1 = (investorId: string) =>
  `${BASE_URL}/v1/kyc/document-with-kyc/${investorId}`
export const GET_INVESTOR_BANK_DETAILS_V1 = (investorId: string) =>
  `${BASE_URL}/v1/kyc/bank-details/${investorId}`
export const UPDATE_KYC_ONS_NOTIFICATION_EMAIL = (investorId: string) =>
  `${BASE_URL}/v1/kyc/ons-notification-settings/${investorId}`
export const GET_INVESTOR_PORTFOLIO_IDS = (investorId: string) =>
  `${BASE_URL}/v1/kyc/investor/${investorId}/portfolio-ids`
export const LIST_INVESTMENT_LIMIT_REQUESTS_V1 = `${BASE_URL}/v1/kyc/investment-limit-requests`
export const GET_INVESTMENT_LIMIT_REQUEST_V1 = (id: string) =>
  `${BASE_URL}/v1/kyc/investment-limit-requests/${id}`
export const UPDATE_INVESTMENT_LIMIT_REQUEST_V1 = (id: string) =>
  `${BASE_URL}/v1/kyc/investment-limit-requests/${id}`

// Withdrawal route
export const SEARCH_WITHDRAWALS_V1 = `${BASE_URL}/v1/withdrawals/search`

export const SEARCH_WALLET_TOPUPS_V1 = `${BASE_URL}/v1/wallet/topups/search`
export const WALLET_TOPUP_STATUS_V1 = (id: string | number) =>
  `${BASE_URL}/v1/wallet/topups/${id}/status`
export const SEARCH_WALLET_WITHDRAWALS_V1 = `${BASE_URL}/v1/wallet/withdrawals/search`
export const WALLET_WITHDRAWAL_STATUS_V1 = (id: string | number) =>
  `${BASE_URL}/v1/wallet/withdrawals/${id}/status`
export const MANUAL_SHARE_SALE_V1 = (opportunityId: string | number) =>
  `${BASE_URL}/v1/opportunity/${opportunityId}/manual-sell`
export const ADMIN_INVESTOR_WALLET_V1 = (investorId: string | number) =>
  `${BASE_URL}/v1/wallet/investor/${investorId}`
export const GET_WITHDRAWAL_REQUEST_DETAILS_BY_ID_V1 = (
  investorId: string,
  opportunityId: string,
) => `${BASE_URL}/v1/withdrawals/investor/${investorId}/opportunity/${opportunityId}`
export const UPDATE_WITHDRAWAL_STATUS_V1 = (withdrawalId: string) =>
  `${BASE_URL}/v1/withdrawals/${withdrawalId}`

// Unit price update route
export const UPLOAD_UNIT_PRICE_UPDATE = `${BASE_URL}/v1/transaction/unit-prices/upload`

// Interest payout routes (admin)
export const INTEREST_PAYOUTS_PREVIEW_V1 = `${BASE_URL}/v1/transaction/interest-payouts/preview`
export const INTEREST_PAYOUTS_V1 = `${BASE_URL}/v1/transaction/interest-payouts`

// Dividend declaration / payout routes (admin)
export const DIVIDEND_DECLARATIONS_UPLOAD_V1 = `${BASE_URL}/v1/transaction/dividend-declarations/upload`
export const DIVIDEND_PAYOUTS_PREVIEW_V1 = `${BASE_URL}/v1/transaction/dividend-payouts/preview`
export const DIVIDEND_PAYOUTS_V1 = `${BASE_URL}/v1/transaction/dividend-payouts`

// Opportunity interest / allocation requests (admin)
export const OPPORTUNITY_INTERESTS_V1 = `${BASE_URL}/v1/opportunity-interest`
export const OPPORTUNITY_INTEREST_BY_ID_V1 = (id: string | number) =>
  `${BASE_URL}/v1/opportunity-interest/${id}`

// CRM route
export const ADD_CRM_EVENT = `${BASE_URL}/v1/crm/event`

// Audit routes
export const AUDIT_EVENTS = `${BASE_URL}/v1/audit/events`
export const AUDIT_EVENTS_BATCH = `${BASE_URL}/v1/audit/events/batch`

// Secondary market
export const SECONDARY_MARKET_ORDERS_V1 = `${BASE_URL}/v1/secondary-market/orders`
export const SECONDARY_MARKET_SETTINGS_V1 = `${BASE_URL}/v1/secondary-market/settings`
export const SECONDARY_MARKET_MATCH_V1 = `${BASE_URL}/v1/secondary-market/orders/match`
export const SECONDARY_MARKET_ORDER_STATUS_V1 = (orderId: number | string) =>
  `${BASE_URL}/v1/secondary-market/orders/${orderId}/status`

// Client Opportunity Terms route
export const INVESTOR_OPPORTUNITY_TERMS = `${BASE_URL}/v1/investor-opportunity-terms`
export const ELIGIBLE_FOR_CUSTOM_TERMS = `${BASE_URL}/v1/opportunity/custom-terms-eligible`

// Uploaded portfolio statements (admin)
export const ADMIN_INVESTOR_PORTFOLIO_STATEMENTS = (investorId: string | number) =>
  `${BASE_URL}/v1/admin/investors/${investorId}/portfolio-statements`
export const ADMIN_INVESTOR_PORTFOLIO_STATEMENT = (
  investorId: string | number,
  statementId: string,
) => `${BASE_URL}/v1/admin/investors/${investorId}/portfolio-statements/${statementId}`
export const PORTFOLIO_STATEMENT_DOWNLOAD = (statementId: string) =>
  `${BASE_URL}/v1/portfolio-statements/${statementId}/download`
// Blogs.
export const GET_BLOGS = `${BASE_URL}/v1/blogs`
export const GET_BLOG_BY_ID = (id: string) => `${BASE_URL}/v1/blogs/${id}`
export const CREATE_BLOG = `${BASE_URL}/v1/blogs/create`
export const UPDATE_BLOG_BY_ID = (id: string) => `${BASE_URL}/v1/blogs/${id}/update`

// Webinars
export const GET_WEBINARS_MANAGE = `${BASE_URL}/v1/webinars/manage`
export const GET_WEBINAR_BY_ID = (id: string) => `${BASE_URL}/v1/webinars/${id}`
export const CREATE_WEBINAR = `${BASE_URL}/v1/webinars/create`
export const UPDATE_WEBINAR_BY_ID = (id: string) => `${BASE_URL}/v1/webinars/${id}/update`

// FAQs (admin + public list)
export const GET_FAQS_V1 = `${BASE_URL}/v1/faqs`
export const CREATE_FAQ_V1 = `${BASE_URL}/v1/faqs`
export const UPDATE_FAQ_V1 = (id: number) => `${BASE_URL}/v1/faqs/${id}`
export const DELETE_FAQ_V1 = (id: number) => `${BASE_URL}/v1/faqs/${id}`

// Opportunity questions (admin)
export const GET_ADMIN_OPPORTUNITY_QUESTIONS = `${BASE_URL}/v1/admin/opportunity-questions`
export const GET_ADMIN_OPPORTUNITY_QUESTION = (id: number | string) =>
  `${BASE_URL}/v1/admin/opportunity-questions/${id}`
export const REPLY_ADMIN_OPPORTUNITY_QUESTION = (id: number | string) =>
  `${BASE_URL}/v1/admin/opportunity-questions/${id}/reply`

// Coming soon opportunities (admin)
export const COMING_SOON_ADMIN_LIST = `${BASE_URL}/v1/coming-soon-opportunities/manage`
export const COMING_SOON_BY_ID = (id: string) => `${BASE_URL}/v1/coming-soon-opportunities/${id}`
export const COMING_SOON_CREATE = `${BASE_URL}/v1/coming-soon-opportunities`
export const COMING_SOON_UPDATE = (id: string) => `${BASE_URL}/v1/coming-soon-opportunities/${id}`
export const COMING_SOON_DELETE = (id: string) => `${BASE_URL}/v1/coming-soon-opportunities/${id}`

// Newsletter.
export const GET_NEWSLETTER_SUBSCRIBERS = `${BASE_URL}/v1/newsletter/subscribers/list`
export const GET_NEWSLETTER_GROUPS = `${BASE_URL}/v1/newsletter/groups/list`
export const CREATE_NEWSLETTER_GROUP = `${BASE_URL}/v1/newsletter/groups/create`
export const GET_NEWSLETTER_GROUP_BY_ID = (groupId: string) =>
  `${BASE_URL}/v1/newsletter/groups/${groupId}`
export const UPDATE_NEWSLETTER_GROUP_BY_ID = (groupId: string) =>
  `${BASE_URL}/v1/newsletter/groups/${groupId}`
export const SEND_NEWSLETTER = `${BASE_URL}/v1/newsletter/send`

// Job schedules (NEWS_FETCH and other background jobs).
export const GET_JOB_SCHEDULE = (jobKey: string) => `${BASE_URL}/v1/job-schedules/${jobKey}`
export const UPDATE_JOB_SCHEDULE = (jobKey: string) => `${BASE_URL}/v1/job-schedules/${jobKey}`
export const RUN_JOB_SCHEDULE = (jobKey: string) => `${BASE_URL}/v1/job-schedules/${jobKey}/run`

// Opportunity news (rows stored by the NEWS_FETCH job).
export const LIST_OPPORTUNITY_NEWS = `${BASE_URL}/v1/opportunity-news`
export const OPPORTUNITY_NEWS_BY_ID = (id: number) => `${BASE_URL}/v1/opportunity-news/${id}`

// Superuser admin roster
export const LIST_ADMINS_V1 = `${BASE_URL}/v1/user/admins`
export const UPDATE_ADMIN_ROLE_V1 = (id: number) => `${BASE_URL}/v1/user/admins/${id}/role`
export const RESET_ADMIN_PASSWORD_V1 = (id: number) =>
  `${BASE_URL}/v1/user/admins/${id}/reset-password`
export const DELETE_ADMIN_V1 = (id: number) => `${BASE_URL}/v1/user/admins/${id}`
export const LIST_ADMIN_ROLE_DEFINITIONS_V1 = `${BASE_URL}/v1/user/admin-roles`
export const ADMIN_ROLE_DEFINITION_V1 = (code: string) =>
  `${BASE_URL}/v1/user/admin-roles/${encodeURIComponent(code)}`
// Promotional referral codes (campaigns) — POST/GET/PATCH/DELETE `/v1/promotional-referral-codes`
export const PROMOTIONAL_REFERRAL_CODES_V1 = `${BASE_URL}/v1/promotional-referral-codes`
export const CREATE_PROMOTIONAL_REFERRAL_CODE = PROMOTIONAL_REFERRAL_CODES_V1
export const LIST_PROMOTIONAL_REFERRAL_CODES = PROMOTIONAL_REFERRAL_CODES_V1
export const PROMOTIONAL_REFERRAL_CODE_BY_ID_V1 = (id: string | number) =>
  `${PROMOTIONAL_REFERRAL_CODES_V1}/${id}`

export const ADMIN_TRADING_ACCOUNTS_V1 = `${BASE_URL}/v1/trading/admin/accounts`
export const ADMIN_TRADING_ORDERS_V1 = `${BASE_URL}/v1/trading/admin/orders`
export const ADMIN_TRADING_RECONCILIATION_V1 = `${BASE_URL}/v1/trading/admin/reconciliation`
export const ADMIN_TRADING_SETTLEMENTS_V1 = `${BASE_URL}/v1/trading/admin/settlements`
export const ADMIN_TRADING_FUNDING_CONFIG_V1 = `${BASE_URL}/v1/trading/admin/funding-config`
export const ADMIN_TRADING_JOURNAL_RECONCILIATION_V1 = `${BASE_URL}/v1/trading/admin/journals/reconciliation`
export const ADMIN_TRADING_JOURNALS_ATTENTION_V1 = `${BASE_URL}/v1/trading/admin/journals/attention`
export const ADMIN_TRADING_JOURNAL_ACTION_V1 = (
  journalId: number,
  action: 'refresh' | 'cancel' | 'resolve',
) => `${BASE_URL}/v1/trading/admin/journals/${journalId}/${action}`
